
let frostlinesChart;
let onсeWasFrostlined = false;

function createFroslinesElement(){
    const layout =
    `<div class="js-frostlines-container frostlines-container hidden-block">
        <canvas id="frostlinesChart" class="frostlines"></canvas>
    </div>`
    
    $('.js-video-player').prepend(layout);
}

function showFrostlines(){
    $('.frostlines-container').addClass('active');
};

function hideFrostlines(){
    $('.frostlines-container').removeClass('active');
};

function initFrostlines(){
    !onсeWasFrostlined && createFroslinesElement();
    onсeWasFrostlined = true;
    
    buildFrostlineChart(
        "frostlinesChart",
        getFrostlinesDataset(frostlinesData.red[currentSegment], frostlinesData.blue[currentSegment])
    );
};

function buildFrostlineChart(chart, dataset){
        let element = document.getElementById(chart);

        frostlinesChart = new Chart(element, {
            type: 'scatter',
            data: {
                labels: [],
                datasets: dataset
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: {
                      display: false
                    },
                    tooltip: {
                      enabled: false
                    }
                },
                scales: {
                    y: {
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 1,
                            stepSize: 0.05,
                            callback: function(value) {
                                return value.toFixed(2);
                            }
                        },
                    },
                    x: {
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 1,
                            stepSize: 0.05,
                            callback: function(value) {
                                return value.toFixed(2);
                            }
                        },
                    }
                }
            }
        });
}

function getFrostlinesDataset(red, blue){
    const dataSet = [{
        "data": red,
        "backgroundColor": "rgba(255, 255, 255, 0)",
        "borderColor": "rgba(255,99,132,1)",
        "borderWidth": 3,
        "pointRadius": 0,
        "tension": 0.40000000000000002220446049250313080847263336181640625,
        "showLine": true
    }, {
        "data": blue,
        "backgroundColor": "rgba(255, 255, 255, 0)",
        "borderColor": "rgba(54, 162, 235, 1)",
        "borderWidth": 3,
        "pointRadius": 0,
        "tension": 0.40000000000000002220446049250313080847263336181640625,
        "showLine": true
    }, {
        "data": [{
                "x": 0.0,
                "y": 0.0
            },{
                "x": 0.99999999999999999999999999999999999999999999999999999999,
                "y": 0.9999999999999999999999999999999999999999999999999999
        }],
        "backgroundColor": "transparent",
        "borderColor": "transparent",
    }];

    return dataSet;
};

function adjustFrostlines(currentTime) {
    const currentTimeM = currentTime.toFixed(3);
    const timePoints = mainVideoSegmentsData;

    if (currentTimeM < timePoints[0]) {
        currentSegment =  0;
    } else if (currentTimeM >= timePoints[timePoints.length - 1]) {
        currentSegment =  timePoints.length;
    }

    for (let i = 0; i < timePoints.length - 1; i++) {
        if (currentTimeM >= timePoints[i] && currentTimeM < timePoints[i + 1]) {
            currentSegment = i + 1;
        }
    }

    frostlinesChart.data.datasets[0].data = frostlinesData.red[currentSegment];
    frostlinesChart.data.datasets[1].data = frostlinesData.blue[currentSegment];

    frostlinesChart.update();
}

